import { Info } from 'lucide-react';
import FileUploader from '../../../components/FileUploader';
import React from 'react'

const Contador = ({ tiempoRestante }) => {
    // Si tiempoRestante es null (calculando), no mostrar nada aún.
    if (!tiempoRestante) return null;

    const { horas, minutos, segundos } = tiempoRestante;
    // El tiempo se considera bajo si quedan menos de 10 minutos.
    const tiempoBajo = horas === 0 && minutos < 10;

    return (
        <div className={`text-center mb-6 p-3 rounded-lg border-2 transition-colors duration-300 ${tiempoBajo ? 'bg-red-100 border-red-400' : 'bg-gray-100 border-gray-300'}`}>
            <h3 className="text-lg font-semibold text-gray-800">Tiempo Restante</h3>
            <p className={`text-4xl font-bold font-mono tracking-wider ${tiempoBajo ? 'text-red-600 animate-pulse' : 'text-gray-900'}`}>
                {String(horas).padStart(2, '0')}:{String(minutos).padStart(2, '0')}:{String(segundos).padStart(2, '0')}
            </p>
        </div>
    );
};

const PruebaEnCurso = ({ onFinishTest, tiempoRestante , examenes , formData, setFormData }) => (

  <div className="bg-white p-8 rounded-xl shadow-lg max-w-2xl w-full text-center animate-fade-in">
    <Contador tiempoRestante={tiempoRestante} />
    <h2 className="text-3xl font-bold text-blue-600 mb-6">Prueba Tecnica en curso...</h2>

    <div className="bg-blue-50 border-l-4 border-blue-400 text-blue-800 p-4 my-6 rounded-md text-left flex items-start">
      <Info />
      <div>
        <h4 className="font-bold mb-1">Instrucciones</h4>
        <p className="text-sm">
          Para realizar el examen, por favor oprima el botón de <strong>"Ver Examen"</strong> en cada materia.
          Revise lo que debe realizar y suba en los cuadros correspondientes su archivo. 
          Al final, cuando tenga todos los archivos listos, dé clic en <strong>"Entregar Prueba"</strong> para finalizar.
        </p>

        {/* ✅ Párrafo nuevo añadido aquí */}
        <p className="text-sm text-red-700 font-semibold mt-3">
          Nota: Entrega el proceso lo más detallado posible. Cuida la presentación, tu letra y la ortografía. <strong>Usa la IA con responsabilidad, como una herramienta para complementar tu trabajo, no para reemplazarlo.</strong>
        </p>

      </div>
    </div>

    <div className="space-y-8">
            {examenes && examenes.map((examen) => (
                <div key={examen.id} className="border p-6 rounded-lg text-left shadow-sm">
                    <h3 className="text-xl font-bold text-gray-800 mb-4">{examen.materia}</h3>
                    <a 
                        href={examen.examen}
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-block bg-blue-600 text-white font-semibold py-2 px-5 rounded-lg hover:bg-blue-700 mb-5"
                    >
                        Ver Examen
                    </a>

                    {/* ✅ AJUSTE CLAVE AQUÍ */}
                    <FileUploader 
                        formData={formData}
                        setFormData={setFormData}
                        // Esta es la clave: le decimos al uploader en qué campo del formData debe trabajar.
                        fieldName={examen.materia} 
                        label={`solución de ${examen.materia}`}
                        multiple={false} // Solo un archivo por examen
                        allowedTypes={[
                            // Documentos PDF
                            'application/pdf',
                            // Documentos de Word
                            'application/msword',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            // Documentos de Excel
                            'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            // Documentos de PowerPoint
                            'application/vnd.ms-powerpoint',
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        ]}
                    />

                </div>
            ))}
    </div>
    
    <button 
      onClick={onFinishTest}
      className="bg-green-600 text-white font-semibold py-3 px-8 rounded-lg hover:bg-green-700 transition-colors duration-300"
    >
      Entregar Prueba
    </button>

  </div>
);

export default PruebaEnCurso
